import React, { useEffect, useContext } from 'react';
import { AppContext } from '../../../context/Context';
import { useTranslation } from 'react-i18next';
import '../../../assets/css/buttons.css';
import { SocketContext } from '../../../context/SocketContext';
import toast from 'react-hot-toast';
import { TextField } from '@mui/material';
import {
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
} from '@mui/icons-material/';

function ModalStartShift() {
  const { t } = useTranslation();

  const {
    isFirstShiftOfTheDay,
    updateIsFirstShiftOfTheDay,
    session,
    updateFocusOnMainScreen,
    userInfo,
    operator,
    hall,
    currentUser,
    currentUserID,
    updateIsCashoutPending,
    openSessionTerminal,
    updateShowModalStartShift,
    logoutUser,
    resetTicketsCH,
    resetTransactions,
    updateUserLogin,
    updateCurrentUser,
    updateCurrentUserID,
    updateUserInfo,
    updateIsFullUser,
    updateIsAnonUser,
    updateIsHybridUser,
    updateIsFastUserLogin,

    updateIsPaymentOpen,
    updateIsSellerOpen,
    updatePaymentType,

    updateTotal,
    updatePayCard,
    updatePayCash,

    updateChange,
    updateIsCard,
    updateIsCash,

    updateUserChildren,
    updateUserParent,
    updateUserSiblings,
    updateAdoptedTicket,
    updateShowUserInfoSibling,
  } = useContext(AppContext);

  const [cashOnOpening, setCashOnOpening] = React.useState(0);

  //* DISABLE FOCUS ON MAIN SCREEN AND PREVENT ESCAPE BUTTON
  useEffect(() => {
    updateFocusOnMainScreen(false);

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  //* SOCKET SETUP
  const { socket } = useContext(SocketContext);

  useEffect(() => {
    const handleOpenShift = (data) => {
      if (!data) {
        toast.error(t('error.error'));
      }

      updateShowModalStartShift(false);
      updateIsFirstShiftOfTheDay(false);
      updateFocusOnMainScreen(true);
    };
    socket.on('openShift', handleOpenShift);

    return () => {
      socket.off('openShift', handleOpenShift);
    };
  }, [socket]);

  const handleConfirm = async () => {
    if (isFirstShiftOfTheDay && (cashOnOpening === '' || cashOnOpening === null)) {
      toast.error(t('error.errorCashOnOpening'));
      return;
    }

    socket.emit('openShift', {
      bingoName: hall,
      operator: operator,
      sessionID: session,
      cashOnOpening: isFirstShiftOfTheDay ? Number(cashOnOpening) : null,
    });
  };

  return (
    <div id="react-confirm-alert">
      <div className="react-confirm-alert-overlay">
        <div className="react-confirm-alert">
          <div className="react-confirm-alert-body" style={{ width: '1000px' }}>
            <h1>{t('sales.openShiftTitle')} </h1>
            <p>{t('sales.openShiftText')}</p>

            {isFirstShiftOfTheDay && (
              <TextField
                autoComplete="off"
                label={t('sales.cashOnOpening') + '*'}
                value={cashOnOpening}
                variant="outlined"
                inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                onChange={(e) => {
                  const v = e.target.value;
                  if (/^\d*$/.test(v)) setCashOnOpening(v);
                }}
                className="modal-textfield"
                style={{ marginTop: '16px' }}
              />
            )}

            <div
              className="react-confirm-alert-button-group"
              style={{ marginTop: '55px' }}
            >
              <button
                className="btn-custom-yes"
                onClick={() => {
                  handleConfirm();
                }}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px', // Space between icon and text
                }}
              >
                <CheckCircleIcon style={{ fontSize: '1.2em' }} />

                {t('sales.confirm')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ModalStartShift;
